export const RADEAS_ADMIN = 'RADEAS_ADMIN';                       // Radeas admin (all roles)
export const RADEAS_CLINIC_ADMIN = 'RADEAS_CLINIC_ADMIN';         // Can approve clinic signups
export const RADEAS_USER = 'RADEAS_USER';                         // Radeas base user
export const CLINIC_ADMIN = 'CLINIC_ADMIN';                       // Clinic admin
export const CLINIC_USER = 'CLINIC_USER';                         // Clinic base user
